import { render, staticRenderFns } from "./choose_round.vue?vue&type=template&id=0269e5a8"
import script from "./choose_round.vue?vue&type=script&lang=js"
export * from "./choose_round.vue?vue&type=script&lang=js"
import style0 from "./choose_round.vue?vue&type=style&index=0&id=0269e5a8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports